import { ref } from 'vue'

import type { VehicleRequest } from '@/assets/composables/types'

export const useVehicleData = () => {
  const ecv = ref<VehicleRequest['ecv']>('')
  const brand = ref<VehicleRequest['brand']>(null)
  const model = ref<VehicleRequest['model']>(null)
  const color = ref<VehicleRequest['color']>(null)

  const validation = ref({
    ecv: false,
  })

  const validateForm = (): boolean => {
    validation.value.ecv = !ecv.value

    return !Object.values(validation.value).some((value) => value)
  }

  const resetData = (): void => {
    ecv.value = ''
    brand.value = null
    model.value = null
    color.value = null

    validation.value.ecv = false
  }

  return {
    ecv,
    brand,
    model,
    color,
    validation,
    validateForm,
    resetData,
  }
}
